import { app } from "../flamelink";

export { default as getActive } from "./getActive";

export const getLatest = async ({ limit = 36, startAfter = null } = {}) => {
  const brands = await app.content.get({
    schemaKey: "brand",
    populate: ["thumbnailImage"],
    ...(startAfter !== null && { startAfter }),
    limit,
    fields: ["brandName", "thumbnailImage", "url", "id", "_fl_meta_"],
    orderBy: [
      {
        field: "_fl_meta_.createdDate",
        order: "desc"
      }
    ]
  });

  return brands;
};
